import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Modal,
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MinimizeIcon from '@mui/icons-material/Minimize';

import {
    setRouteMaker,
    selectRouteMaker
} from '../../../features/tripcenter/routeSlice';
import {
    selectCurrentWizardStep,
    resetRouteDetails,
    setIsMinimized,
    selectIsMinimized,
} from '../../../features/tripcenter/googleRouteMakerSlice';

import RouteBuilderWizard from './RouteBuilderWizard';
import CompactRoutePanel from './CompactRoutePanel';
import CompactRouteBuilder from './CompactRouteBuilder';

// Modal styles
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: '85vh',
    maxWidth: '1000px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 1,
    p: 0,
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden', // Prevents overall modal scrolling
};


const RouteBuilderModal = () => {
    const dispatch = useDispatch();
    const routeMaker = useSelector(selectRouteMaker);
    const currentStep = useSelector(selectCurrentWizardStep);
    const isMinimized = useSelector(selectIsMinimized);

    // State to control modal visibility
    const [isOpen, setIsOpen] = useState(false);

    // Open modal when routeMaker is set to 'google'
    useEffect(() => {
        if (routeMaker === 'google') {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [routeMaker]);

    // Handle close
    const handleClose = () => {
        dispatch(resetRouteDetails());
        dispatch(setRouteMaker(null));
    };

    // Handle minimize/maximize
    const handleMinimize = () => {
        dispatch(setIsMinimized(true));
    };


    return (
        <>
            {/* Full Modal View */}
            <Modal
                open={isOpen && !isMinimized}
                onClose={handleClose}
                aria-labelledby="route-builder-modal"
                aria-describedby="route-builder-wizard-modal"
                BackdropProps={{
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
                }}
            >
                <Box sx={modalStyle}>
                    {/* Modal Header with controls */}
                    <Box sx={{
                        p: 2,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid',
                        borderColor: 'divider'
                    }}>
                        <Typography variant="h5">Build a New Route</Typography>
                        <Box>
                            <IconButton
                                onClick={handleMinimize}
                                color="primary"
                                size="small"
                                sx={{ mr: 1 }}
                            >
                                <MinimizeIcon />
                            </IconButton>
                            <IconButton
                                onClick={handleClose}
                                color="primary"
                                size="small"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    {/* Modal Content */}
                    <Box sx={{ flex: 1, overflow: 'hidden' }}>
                        <RouteBuilderWizard isInModal={true} />
                    </Box>
                </Box>
            </Modal>

            {/* Minimized Panel View */}
            {isOpen && isMinimized && currentStep === 'route' ? (
                <CompactRouteBuilder />
            ) : isOpen && isMinimized ? (
                <CompactRoutePanel />
            ) : null}
        </>
    );
};

export default RouteBuilderModal; 